import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { Reveal } from './Reveal';
export function GuaranteeSection() {
  return <section className="bg-white py-16 sm:py-24" data-id="element-105" data-mp="4vrzzwt0kbqc">
      <div className="mx-auto max-w-4xl px-4 sm:px-6" data-id="element-106" data-mp="9umfopvopk68">
        <Reveal data-id="element-107" data-mp="9t1lx2h7259f">
          <div className="flex flex-col items-center gap-6 rounded-3xl bg-ink p-8 text-center text-white sm:flex-row sm:p-10 sm:text-left" data-id="element-108" data-mp="9wphe76791qs">
            <span className="grid h-20 w-20 shrink-0 place-items-center rounded-2xl bg-success/15 text-success-light sm:h-24 sm:w-24" data-id="element-109" data-mp="jtc1uuum5qsa">
              <ShieldCheckIcon className="h-11 w-11 sm:h-14 sm:w-14" aria-hidden="true" data-id="element-110" data-mp="nsb2w4d853eg" />
            </span>
            <div data-id="element-111" data-mp="slm9c4e4ji5u">
              <h2 className="text-2xl font-extrabold tracking-tight sm:text-3xl" data-id="element-112" data-mp="sn6y1ddrc6vs">🛡️ Garantía de 7 días</h2>
              <p className="mt-3 text-base leading-relaxed text-slate-300 sm:text-lg" data-id="element-113" data-mp="12j0dp5mrwghs">
                Si instalas el sistema, lo usas y no te funciona como prometemos, te devolvemos tu dinero.{' '}
                <strong className="text-white" data-id="element-114" data-mp="25rx6cfic6fva">Sin preguntas.</strong>
              </p>
            </div>
          </div>
        </Reveal>
      </div>
    </section>;
}